export enum WelcomeStepsState {
	WELCOME,
	CHOOSE_PLAN
}
